module.exports = __webpack_public_path__ + "img/icon-化学@2x.b0654119.png";